import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_OCTOPUS_TAKO_EDITOR_CONFIG = defineFcm('octopus_tako_editor_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				toolbar: { type: 'string' },
				phase_1_enabled: { type: 'boolean' },
				phase_2_enabled: { type: 'boolean' },
				phase_3_enabled: { type: 'boolean' },
				// Note: Please update with RichTextEditor config properties
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'This FCM is used to configure the Tako rich text editor.',
		description:
			'This FCM is used to configure the rich text editor. Should be an object like this: { "toolbar": "bold italic underline fontsizeselect  forecolor backcolor | link |  bullist emoticons template" } ',
		import: false,
		template: {
			toolbar: 'bold italic underline fontsizeselect  forecolor backcolor | link |  bullist emoticons template',
			phase_1_enabled: false,
			phase_2_enabled: false,
			phase_3_enabled: false,
		},
	});
